<div class="settings-outlet">
  <router-outlet />
</div>
